import { z } from 'zod';

export type FacematchInfo = z.infer<typeof FacematchInfoSchema>;

export const FacematchInfoSchema = z.object({
  key: z.string(),
  documentType: z.string().toUpperCase(),
  status: z.string(),
  underReview: z.boolean(),
  evidences: z.array(z.object({
    url: z.string(),
    capturedAt: z.string().transform((value) => value ?? new Date().toISOString()).nullable(),
    kind: z.string().nullable(),
    name: z.string(),
  }).nullable()),
  provider: z.string().nullable().optional(),
});

export const CreateFacematchInfoSchema = z.object({
  facematch: FacematchInfoSchema,
});

export const faceMatchConfigSchema = z.object({
  asyncChecking: z.object({
    quantity: z.number(),
    intervalInSeconds: z.number(),
  }),
});

export const ocrSchema = z.object({
  documentationMatch: z.enum(['divergence', 'success', 'absence', 'expired']),
});

export const enum DocumentErrors {
  CpfError = 'cpf_error',
  DocumentExpired = 'document_expired',
}
